import { useState, useCallback } from 'react';
import consoleEvents from '../consoleEvents';
import { IS_CLIENT } from '../constants';
import useIsMounted from './useIsMounted';
const useSessionStorage = (key, initialValue) => {
    const getIsMounted = useIsMounted();
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = IS_CLIENT && window.sessionStorage.getItem(key);
            return item || initialValue;
        }
        catch (error) {
            consoleEvents.error(`failed to read from sessionStorage ${error}`);
            return initialValue;
        }
    });
    const setValue = useCallback((value) => {
        try {
            if (getIsMounted()) {
                setStoredValue(value);
            }
            window.sessionStorage.setItem(key, value);
        }
        catch (error) {
            consoleEvents.error(`failed to write to sessionStorage ${error}`);
        }
    }, []);
    return [storedValue, setValue];
};
export default useSessionStorage;
//# sourceMappingURL=useSessionStorage.js.map